// © Microsoft Corporation. All rights reserved.

/** Detects if an entity is a string with contents */
export const stringHasLength = (s: any): boolean => {
    return s && typeof s === "string" && s.trim && !!s.trim();
};